import React, { useState, useEffect } from "react";
import Slider from "src/components/slider";
import { useDispatch, useSelector } from 'react-redux';
import { cloneAsset } from "src/redux/actions/assets";
import { SelectEntity } from "../../../../components/selectEntity /index"; 
import { toast } from "react-toastify";
import Toast from "../../../../components/toast/index";
import { useNavigate } from 'react-router-dom';

import _ from "lodash";
import styles from "./clone.module.scss";
import { Asset } from "src/types/assets";
import Button from "src/components/button";
import { useAssetAdoption } from "src/redux/actions/adoption/asset";
import { FileService } from "src/services/file.service";
import { IUseFetchProps, useFetch } from "src/components/hooks/useFetch";
import { CLONE_ASSET, COLLECTION, STREAM } from "src/constants/adoption/sourceTypes";


interface CloneAssetProps {
  show: boolean;
  onClose: () => void;
  asset: Asset;
}

interface SelectedDestination {
  id: '';
  name: '';
  type: "stream" | "group" | "collection" | "collection_section";
}

const CloneAsset: React.FC<CloneAssetProps> = ({ show, onClose, asset }) => {

  const {trackAssetCloneScreenView, trackAssetCloned, trackDestinationSelected} = useAssetAdoption();

  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  
  const [selectedDestination, setSelectedDestination] = useState<SelectedDestination>({
    id: "",
    name: "",
    type: "stream"
  });

  const cloning = useSelector((state: any) => _.get(state, "asset.clone.cloning", false));
  const cloned = useSelector((state: any) => _.get(state, "asset.clone.cloned", false));
  const clonedItem = useSelector((state: any) => _.get(state, "asset.clone.item", null));
  const error = useSelector((state: any) => state.asset.clone.error?.errors?.[0]);
  const isStorageLimitReached = useSelector((state: any) => state.asset.storageLimit.isLimitReached)

  const cloneAssetProps: IUseFetchProps = {
    action: cloneAsset,
    loading: cloning,
    succeeded: cloned,
    response: clonedItem,
    error: null
  };

  const { handleFetch: cloneAssetRequest } = useFetch(cloneAssetProps);


  const handleSelection = (entityType: "stream" | "group" | "collection" | "collection_section", id: '', name: '') => {
    
    const fileType = FileService.getFileType(asset.metadata);
    if(entityType === "stream"){
      trackDestinationSelected({assetType: fileType, destinationType: STREAM, sourceCta: CLONE_ASSET, collectionName:"", streamName:name});
    }

    if(entityType === "collection"){
      trackDestinationSelected({assetType: fileType, destinationType: COLLECTION, sourceCta: CLONE_ASSET, collectionName:name, streamName:""});
    }

    setSelectedDestination({ id, name, type: entityType });
  };

  const handleCloneAsset = async () => {
    if (!selectedDestination.id || !selectedDestination.type) {
      return;
    }

    cloneAssetRequest({
      id: asset.id,
      destination: {
        entityType: selectedDestination.type,
        id: selectedDestination.id,
      },
    }).then((response) => {
      const fileType = FileService.getFileType(response.metadata);
      const destinationType = selectedDestination.type;
      let streamName = "";
      let collectionName = "";

      if (
        destinationType === "stream" || 
        destinationType === "group"
      ) {
        streamName = selectedDestination.name;
      }

      if (
        destinationType === "collection" ||
        destinationType === "collection_section"
      ) {
        collectionName = selectedDestination.name;
      }

      trackAssetCloned({
        assetType: fileType,
        destinationType: selectedDestination.type,
        collectionName: collectionName,
        streamName: streamName,
      });
    });
  };

  useEffect(() => {
    trackAssetCloneScreenView();
  }, []);

  useEffect(() => {
    if (isStorageLimitReached && error?.code) {
      toast(<Toast.warning heading="Warning" message={error?.message} />, {
        position: "bottom-right",
        autoClose: false,
      });
    }
  }, [isStorageLimitReached])
  
  useEffect(() => {
    if (cloned && selectedDestination.id && selectedDestination.name) {
      const clonedAssetId = clonedItem.id;
      const successMessage = (
        <div>
          Your asset <span className={styles.clonedAsset}>"{asset.name}"</span> is cloned to the {selectedDestination.type === "stream" ? 'stream' : selectedDestination.type === "group" ? 'group' : selectedDestination.type === "collection_section" ? 'Collection section' : 'collection'} <span className={styles.clonedAsset}>"{selectedDestination.name}"</span>.
          <div>
            <button
              className={styles.successToastMessage} 
              onClick={() => {
                onClose(); 
                toast.dismiss();
                navigate(`/assets/${clonedAssetId}`);
                navigate(0);
              }}
            >
              <i className="paperflite-right-arrow"/>
              Go to cloned asset
            </button>
          </div>
        </div>
      );

      toast(<Toast.Sucess className={styles.toastComponent} message={successMessage} />);
      
      setSelectedDestination({ id: "", name: "", type: "stream" });
      onClose();
    }
  }, [cloned]);

  const disabled = !(selectedDestination.id && selectedDestination.type);

  return (
    <Slider.Dialog width={"380"} show={show} onClose={onClose}>
      <Slider.Header title="You are making a clone of">
        <div>
          <div className={styles.heading}>{asset.name}</div>
          <p className={styles.decription}>
          Now find a home for it.
          </p>
        </div>
      </Slider.Header>
      <Slider.Body>
        <SelectEntity
          style={{}}
          width={340}
          height={55}
          onSelection={(entity) =>{
            handleSelection(entity.entityType, entity.id, entity.name)}
          }
          selectedEntity={selectedDestination}
        />
      </Slider.Body>
      {selectedDestination.name && (
        <div className={styles.cloneAssetDescription}>
          Cloning this asset to {" "}
          <span className={styles.clonedAsset}>{selectedDestination.name}</span>
        </div>
      )}
      <Slider.Actions>
        <Button
          icon="paperflite-tick"
          variant="primary"
          onClick={() => handleCloneAsset()}
          disabled={disabled}
          text={cloning ? "Cloning..." : "Clone"}
        />
        <Button onClick={onClose} text="Cancel" />
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default CloneAsset;
